import { isStringDirty } from "@suse-o11y/is-string-dirty";
import { FormShape, FormUnit } from "@suse-o11y/signal/form";
import type { Template } from "@suse-o11y/template";

import {
	type DashboardMetricPromQLVariable,
	dashboardMetricPromQLVariableSchema,
} from "../../../../common/dashboard-spec";
import type { FormProcessor } from "../../_form-processor";
import { LabelNameFormProcessor, type LabelNameFormState } from "../_label-name";

export type FormState = FormShape<{
	expression: FormUnit<string, ReadonlyArray<string>, Template<["${", "}"], null>>;
	labelName: LabelNameFormState;
}>;

export const Processor: FormProcessor<FormState, undefined | DashboardMetricPromQLVariable> = {
	fromSpec: (spec) =>
		FormShape({
			expression: FormUnit(spec?.expr.source ?? "", {
				isInputDirty: isStringDirty,
				schema: dashboardMetricPromQLVariableSchema.shape.expr,
			}),
			labelName: LabelNameFormProcessor.fromSpec(spec?.labelName),
		}),

	toSpec: ({ expression, labelName }) => ({ expr: expression, labelName }),
};
